'use strict';

module.exports = String.fromCharCode;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/chr.js
// module id = 48
// module chunks = 0